var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "overflow-hidden": _vm.isShowingSideMenuOverAll } },
    [
      _vm.badgeEnv
        ? _c(
            "b-badge",
            { staticClass: "badge-env", attrs: { variant: "danger" } },
            [_vm._v(" " + _vm._s(_vm.badgeEnv))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "background-create-annonce": _vm.isActiveRoute(
              _vm.lighterBackgroundRoutes
            )
          },
          attrs: { id: "app" }
        },
        [
          _vm.hideNavigation
            ? _c("div", [
                _c(
                  "div",
                  [
                    _c(
                      "transition",
                      { attrs: { mode: "out-in", name: "fade" } },
                      [_c("router-view")],
                      1
                    )
                  ],
                  1
                )
              ])
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "row no-gutters" },
                  [
                    !_vm.isDesktopNavigation
                      ? _c(
                          "b-collapse",
                          {
                            staticClass: "part-sidebar col-12 darker-theme",
                            attrs: { id: "sidebar-mobile" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { id: "sidebar" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-end sidebar-mobile-close-container"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName:
                                              "v-b-toggle.sidebar-mobile",
                                            modifiers: {
                                              "sidebar-mobile": true
                                            }
                                          }
                                        ],
                                        staticClass: "ml-auto mobile-menu-icon"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "ph-custom ph-x sidebar-mobile-close-icon"
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-nav",
                                  { attrs: { vertical: "" } },
                                  [
                                    _c("SideMenu", {
                                      key: _vm.sideMenuKey,
                                      attrs: {
                                        links:
                                          _vm.sidebarLinksAndDesktopMenuLinks,
                                        windowHeight: _vm.windowHeight
                                      },
                                      on: {
                                        clickAction: _vm.sideMenuClickAction
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 main-color-background",
                        class: {
                          "background-create-annonce": _vm.isActiveRoute(
                            _vm.lighterBackgroundRoutes
                          )
                        }
                      },
                      [
                        _c(
                          "b-navbar",
                          {
                            staticClass:
                              "navbar-hover-body d-block sticky-navbar",
                            class: {
                              "no-sticky-navbar-for-md-annonce-create": _vm.isActiveRoute(
                                ["/annonce/create"]
                              )
                            },
                            attrs: { toggleable: "md" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "navbar p-0 justify-content-start"
                              },
                              [
                                _c("b-navbar-brand", [
                                  _c("div", [
                                    _c("img", {
                                      staticClass: "navbar-icon",
                                      class: {
                                        "navbar-icon-clickable": !_vm.isActiveRoute(
                                          ["/"]
                                        )
                                      },
                                      attrs: {
                                        src: require("@/assets/images/b122/ic_lamp_logo.png"),
                                        alt: "Logo"
                                      },
                                      on: { click: _vm.goToHome }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.displayFilters
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mr-1 d-flex align-items-center",
                                        class: {
                                          "navbar-desktop-left-part":
                                            _vm.isDesktopNavigation
                                        }
                                      },
                                      [
                                        _vm.isDesktopNavigation
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mr-1 b-collapse-horizontal collapse",
                                                class: {
                                                  show: !_vm.isSearchCollapsed
                                                },
                                                attrs: {
                                                  id: "searchbar-desktop"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "d-flex w-100",
                                                    attrs: {
                                                      id:
                                                        "searchbar-desktop-inside"
                                                    }
                                                  },
                                                  [
                                                    _c("SearchBarForm", {
                                                      attrs: {
                                                        id:
                                                          "searchbarform-desktop",
                                                        isDesktop: true,
                                                        searchInitial:
                                                          _vm.search
                                                      },
                                                      on: {
                                                        didUpdateSearchText:
                                                          _vm.didUpdateSearchText,
                                                        didValidateSearchText:
                                                          _vm.didValidateSearchText
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-toggle",
                                                rawName:
                                                  "v-b-toggle.searchbar-mobile",
                                                modifiers: {
                                                  "searchbar-mobile": true
                                                }
                                              }
                                            ],
                                            ref: "navbarSearchBtnOpenClose",
                                            staticClass:
                                              "mr-1 d-flex btn-icon-navbar btn-icon-navbar-more-centered navbar-search-ele-must-be-clicked",
                                            class: {
                                              "": !_vm.isSearchCollapsed
                                            },
                                            attrs: {
                                              disabled:
                                                _vm.$store.state
                                                  .identityToSubmit === true,
                                              variant: "navbar-primary"
                                            },
                                            on: {
                                              click: _vm.toggleSearchCollapse
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "ph-custom align-self-center navbar-search-ele-must-be-clicked",
                                              class: {
                                                "ph-magnifying-glass":
                                                  _vm.isSearchCollapsed,
                                                "ph-caret-left":
                                                  !_vm.isSearchCollapsed &&
                                                  _vm.isDesktopNavigation,
                                                "ph-caret-up":
                                                  !_vm.isSearchCollapsed &&
                                                  !_vm.isDesktopNavigation
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.isDesktopNavigation &&
                                        _vm.isSearchCollapsedFollowingCollapsed
                                          ? [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "mr-1 d-flex navbar-button-filters-modal",
                                                  attrs: {
                                                    variant: _vm.isSelectedFilterLocation
                                                      ? "navbar-secondary-inversed"
                                                      : "navbar-secondary",
                                                    disabled:
                                                      _vm.$store.state
                                                        .identityToSubmit ===
                                                      true
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goToSearch(
                                                        "localisation"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "ph-custom ph-map-pin align-self-center"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Filters.localisation"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "mr-1 navbar-button-filters-modal",
                                                  attrs: {
                                                    variant:
                                                      _vm.nbSelectedFilterVehicleType >
                                                      0
                                                        ? "navbar-secondary-inversed"
                                                        : "navbar-secondary",
                                                    disabled:
                                                      _vm.$store.state
                                                        .identityToSubmit ===
                                                      true
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goToSearch(
                                                        "vehicles"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedVehicleTypeText
                                                          ? _vm.selectedVehicleTypeText
                                                          : _vm.$t(
                                                              "Filters.vehicles"
                                                            )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "mr-1 navbar-button-filters-modal",
                                                  attrs: {
                                                    variant:
                                                      _vm.nbSelectedFilterBrand >
                                                      0
                                                        ? "navbar-secondary-inversed"
                                                        : "navbar-secondary",
                                                    disabled:
                                                      _vm.$store.state
                                                        .identityToSubmit ===
                                                      true
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goToSearch(
                                                        "brands"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedBrandText
                                                          ? _vm.selectedBrandText
                                                          : _vm.$t(
                                                              "Filters.brands"
                                                            )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "mr-1 d-flex navbar-button-filters-modal",
                                            class: {
                                              "btn-icon-navbar btn-icon-navbar-more-centered-more-width mr-2": !_vm.isDesktopNavigation
                                            },
                                            attrs: {
                                              variant:
                                                (_vm.isDesktopNavigation &&
                                                  (_vm.isSelectedOneFilterExceptLocation ||
                                                    (!_vm.isSearchCollapsedFollowingCollapsed &&
                                                      _vm.isSelectedOneFilter))) ||
                                                (!_vm.isDesktopNavigation &&
                                                  _vm.isSelectedOneFilter)
                                                  ? "navbar-secondary-inversed"
                                                  : "navbar-secondary",
                                              disabled:
                                                _vm.$store.state
                                                  .identityToSubmit === true
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.goToSearch("filters")
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "ph-custom ph-faders align-self-center"
                                            }),
                                            _vm._v(" "),
                                            _vm.isDesktopNavigation
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Filters.filters")
                                                    )
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isDesktopNavigation
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ml-auto d-flex navbar-desktop-right-part"
                                      },
                                      [
                                        _vm.displayAnnonceCreateBtn
                                          ? _c(
                                              "b-button",
                                              {
                                                staticClass: "mr-3",
                                                attrs: {
                                                  variant: "navbar-primary"
                                                },
                                                on: {
                                                  click: _vm.goToAnnonceCreate
                                                }
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Menu.create.annonce"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-collapse",
                                          {
                                            attrs: {
                                              id: "accountIconAndMenuDesktop",
                                              "is-nav": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "b-navbar-nav",
                                              [
                                                _c(
                                                  "b-nav-item-dropdown",
                                                  {
                                                    staticClass:
                                                      "dropdown-custom dropdown-my-account-custom",
                                                    attrs: { right: "" },
                                                    on: {
                                                      click:
                                                        _vm.goToAnnonceCreate
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "button-content",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex desktop-menu-icon-user"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "mr-2_5"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.userNames
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "ph-custom ph-user-circle align-self-center"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      2426340088
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.sidebarLinksAndDesktopMenuLinks,
                                                      function(linkData) {
                                                        return [
                                                          linkData.isInDesktopMenu &&
                                                          linkData.hasTopSep
                                                            ? _c("div", {
                                                                staticClass:
                                                                  "dropdown-sep-custom"
                                                              })
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          linkData.isInDesktopMenu
                                                            ? _c(
                                                                "b-dropdown-item",
                                                                {
                                                                  class:
                                                                    linkData.customClassDesktop,
                                                                  attrs: {
                                                                    disabled: _vm.isActiveRoute(
                                                                      linkData.routesActiveItem
                                                                    )
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      linkData.onClickAction
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "d-flex",
                                                                      class: {
                                                                        activeItem: _vm.isActiveRoute(
                                                                          linkData.routesActiveItem
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "ph-custom align-self-center mr-2",
                                                                        class:
                                                                          linkData.icon
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              linkData.title
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-collapse",
                                          {
                                            attrs: {
                                              id: "notifIconAndNotifMenu",
                                              "is-nav": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "b-navbar-nav",
                                              [
                                                _c(
                                                  "b-nav-item-dropdown",
                                                  {
                                                    staticClass:
                                                      "ml-2 dropdown-custom dropdown-notifs-custom",
                                                    attrs: { right: "" },
                                                    on: {
                                                      click:
                                                        _vm.goToAnnonceCreate,
                                                      hide:
                                                        _vm.updateNotifications,
                                                      "bv::dropdown::show":
                                                        _vm.onDropdownShow
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "button-content",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "desktop-menu-icon align-self-center desktop-menu-icon-bell"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "ph-custom ph-bell align-self-center"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      4137655201
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-dropdown-item",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.preventDropdownClose.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("NotifsMenu", {
                                                          ref: "notifsMenu",
                                                          attrs: {
                                                            windowHeight:
                                                              _vm.windowHeight
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "ml-auto d-flex" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "b-toggle",
                                                rawName:
                                                  "v-b-toggle.sidebar-mobile",
                                                modifiers: {
                                                  "sidebar-mobile": true
                                                }
                                              }
                                            ],
                                            staticClass:
                                              "mobile-menu-icon ml-2 mobile-menu-icon-user"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "ph-custom ph-user-circle align-self-center"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "b-toggle",
                                                rawName:
                                                  "v-b-toggle.sidebar-mobile-notifs",
                                                modifiers: {
                                                  "sidebar-mobile-notifs": true
                                                }
                                              }
                                            ],
                                            staticClass:
                                              "mobile-menu-icon ml-3 mobile-menu-icon-bell pr-3"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "ph-custom ph-bell align-self-center"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isDesktopNavigation
                              ? _c(
                                  "b-collapse",
                                  { attrs: { id: "searchbar-mobile" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "navbar-searchbar-mobile"
                                      },
                                      [
                                        _c("SearchBarForm", {
                                          attrs: {
                                            id: "searchbarform-mobile",
                                            searchInitial: _vm.search
                                          },
                                          on: {
                                            didUpdateSearchText:
                                              _vm.didUpdateSearchText,
                                            didValidateSearchText:
                                              _vm.didValidateSearchText
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "page-container" },
                          [
                            _c(
                              "transition",
                              { attrs: { mode: "out-in", name: "fade" } },
                              [_c("router-view")],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isActiveRoute([
                              "/annonce/create",
                              "/annonce/edit"
                            ])
                              ? _c("div", { staticClass: "main-footer" }, [
                                  _c("p", [
                                    _vm._v(
                                      "Copyright © 2023 " +
                                        _vm._s(_vm.$t("TitleProjectUC")) +
                                        ".\n                "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "white-space": "nowrap" }
                                      },
                                      [_vm._v("All rights reserved.")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: { "white-space": "nowrap" }
                                    },
                                    [
                                      _vm._v("Made with\n                "),
                                      _c("heart-icon", {
                                        staticStyle: {
                                          color: "var(--main-yellow-medium)"
                                        }
                                      }),
                                      _vm._v("\n                by "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "footer-bleu122-link",
                                          attrs: {
                                            href: "https://www.bleu122.com/"
                                          }
                                        },
                                        [_vm._v("Bleu122")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isDesktopNavigation
                      ? _c(
                          "b-collapse",
                          {
                            staticClass: "part-sidebar col-12 darker-theme",
                            attrs: { id: "sidebar-mobile-notifs" },
                            on: { hide: _vm.updateNotifications }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { id: "sidebar-notifs" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-end sidebar-mobile-close-container"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName:
                                              "v-b-toggle.sidebar-mobile-notifs",
                                            modifiers: {
                                              "sidebar-mobile-notifs": true
                                            }
                                          }
                                        ],
                                        staticClass: "ml-auto mobile-menu-icon"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "ph-custom ph-x sidebar-mobile-close-icon"
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("NotifsMenu", {
                                  ref: "notifsMenu",
                                  attrs: {
                                    "is-mobile": true,
                                    windowHeight: _vm.windowHeight
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
          _vm._v(" "),
          _c("first-connexion-modal", {
            ref: "firstConnexionModal",
            attrs: { isFirstConnexion: _vm.isFirstConnexion }
          }),
          _vm._v(" "),
          _c("identity-to-validate-modal"),
          _vm._v(" "),
          _c("support-modal"),
          _vm._v(" "),
          _c("show-bug-report-modal"),
          _vm._v(" "),
          _c("ScanMenu"),
          _vm._v(" "),
          _c("identity-to-submit-modal", {
            attrs: { "no-close": _vm.noCloseModal }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = xLOO
// module chunks = 0